<template>
  <div class="md-layout">

    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 " style="margin:0 auto;">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100  text-right">
          <h1 class="section-header">{{$t('contact-us')}}</h1>
        </div>
        <!-- <div class="md-layout-item md-size-80 md-small-size-100">
          <div style="margin:1rem; outline: 1px solid black; padding: 1rem" v-show="store === 'jp'">
            <p>
              <strong>
                カスタマーサポートサービス
                <span style="color:red">夏季休暇のお知らせ 期間：2023年8月11日（金）～2023年8月17日（木）	</span>
              </strong>
            </p>

            <p>
              (修理品受付に関して)<br>
              8/7（月）までの着荷	：休暇前の出荷を予定（※在庫状況など内容によっては、休暇明けの処理になる場合がございます。）<br>
              8/8（火）以降の着荷	：休暇明けの処理になる可能性がございます。<br>
            </p>

            <p>
              なお、配送業者の休日や交通事情等によりお届けが遅くなる場合がございます。<br>
              また、休暇明けは混雑が予想され、通常よりご確認、ご返送等にお時間がかかる場合がございます。<br>
              あらかじめご了承ください。<br>
            </p>
          </div>
        </div> -->
      </div>
    </div>

    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100 page-container-side text-right">
          <div style="width:80%;float:right"><h3>{{$t('mode-of-contact')}}</h3></div>
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100">

          <div class="page-container-section">
            <div>{{$t('select-mode-of-contact')}}</div>
            <div>
              <md-radio v-model="radio" :value="false" v-on:change="closeChat()">{{$t('email-us')}}</md-radio>
            </div>
            <div v-if="showChat">
              <md-radio v-model="radio" :value="true" v-on:change="clickChat()">Online Chat <div>: online</div></md-radio>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>




<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ModeOfContact',
    data: () => ({
      showChat: false,
      radio: false
    }),
    computed: {
      ...mapState({
        store: 'store'
      })
    },
    methods: {
      closeChat() {
        if (typeof (window.zE) == 'function') {
          window.zE('messenger', 'close')
        }
        return
    },
    clickChat() {
      if (typeof (window.zE) == 'function') {
        window.zE('messenger', 'open')
      }
      return
    },
  },
    created() {

      switch (this.store.toUpperCase()) {
        case "SG":
        case "AU":
        case "US":
        case "CA":
        case "UK":
          this.showChat = true;
          break;

        default:
          this.showChat = false;
          break;
      }

      // if (typeof(window.zE) == 'function') {
      //   window.zE('messenger:on', 'chat:status', function (status) {
      //     window.console.log('Chat Status (ModeOfContact.vue): ' + status)
      //   })
      // }
    }
  }
</script>

<style lang="scss" scoped>
  small {
    display: block;
  }
  .md-radio:not(.md-disabled), .md-radio:not(.md-disabled) .md-radio-label {
    margin: 5px 0;
  }
  .md-radio-label > div {
    float: right;
    margin-left: 5px;
    text-transform: capitalize;
  }
</style>
